export class Emails
{
   id_email: number = 0;
   endereco_email: string = '';
   obs_email: string = '';
   id_pessoa: number = 0; 
   alterado: string = '';
}